module.exports = __webpack_public_path__ + "static/typographytools-4be7cc286d34a8a901893730812bda38.webp";